<div *ngIf="loading" class="container" style="padding:40px 24px">
    Loading home page...
</div>

<div *ngIf="errorMessage" class="container" style="padding:40px 24px">
    <div class="alert error">{{ errorMessage }}</div>
</div>

<ng-container *ngIf="data && !loading">
    <div class="home-page-clean">

        <!-- HERO -->
        <section class="hero">
            <div class="container">
                <div>
                    <h1>{{ data.hero?.title }}</h1>

                    <p>{{ data.hero?.description }}</p>

                    <div class="hero-cta">
                        <a class="btn btn-primary" [routerLink]="data.hero?.primaryUrl">
                            {{ data.hero?.primaryText }}
                        </a>

                        <a class="btn btn-ghost" [routerLink]="data.hero?.secondaryUrl">
                            {{ data.hero?.secondaryText }}
                        </a>
                    </div>

                </div>


            </div>
        </section>

        <!-- TRUST BAR -->
        <div class="container trust-bar">
            <div class="trust-grid">
                <div class="trust-item" *ngFor="let t of data.trustItems">
                    <strong>{{ t.title }}</strong>
                    <span>{{ t.description }}</span>
                </div>
            </div>
        </div>

        <!-- SERVICES -->
        <section class="section">
            <div class="container">
                <div class="section-head">
                    <div>
                        <span class="section-kicker">Capabilities</span>
                        <h2>Core IOSC services at a glance.</h2>
                    </div>
                    <p>These service cards are loaded dynamically from SQL Server.</p>
                </div>

                <div class="capability-grid">
                    <article class="cap-card reveal" *ngFor="let s of data.services">
                        <div class="service-img" [ngClass]="s.iconKey">
                        </div>

                        <h3>{{ s.title }}</h3>
                        <p>{{ s.description }}</p>

                        <a class="learn" [routerLink]="s.ctaUrl || '/contact'">
                            {{ s.ctaText || 'Request service →' }}
                        </a>
                    </article>
                </div>
            </div>
        </section>

        <!-- INDUSTRIES -->
        <section class="section industries-section">
            <div class="container">
                <div class="section-head">
                    <div>
                        <span class="section-kicker">Industries</span>
                        <h2>Serving demanding operational environments.</h2>
                    </div>
                    <p>IOSC supports organizations where reliability, documentation and response time matter.</p>
                </div>

                <div class="industry-grid">
                    <article class="industry-card reveal" *ngFor="let i of data.industries">
                        <h3>{{ i.title }}</h3>
                        <p>{{ i.description }}</p>
                    </article>
                </div>
            </div>
        </section>


        <!-- PROCESS -->
        <section class="section dark-band">
            <div class="container">
                <div class="section-head">
                    <div>
                        <span class="section-kicker">How we work</span>
                        <h2>Fast RFQ to field delivery.</h2>
                    </div>
                    <p>Clear process for urgent and planned project requirements.</p>
                </div>

                <div class="process-grid">
                    <div class="process reveal" *ngFor="let p of data.process">
                        <h3>{{ p.title }}</h3>
                        <p>{{ p.description }}</p>
                    </div>
                </div>
            </div>
        </section>

        <!-- TRUST & COMPLIANCE -->
        <section class="section trust-section">
            <div class="container">
                <div class="trust-panel-pro reveal">
                    <div>
                        <span class="section-kicker">Trust & Compliance</span>
                        <h2>Built around quality, safety and documentation.</h2>
                        <p>Use this section to highlight certificates, supplier approvals, operational standards and regional capability.</p>
                        <a class="btn btn-primary" routerLink="/certificates">View Certificates</a>
                    </div>

                    <div class="trust-badges">
                        <div *ngFor="let b of data.badges">
                            <b>{{ b.title }}</b>
                            <span>{{ b.description }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>



    </div>
</ng-container>